module.exports = __webpack_public_path__ + "img/old_fashioned.a4d913f9.jpg";